import { Button } from "@/components/ui/Button";
import { PlusIcon } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export function BulkMessageHeader() {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();

  return (
    <section
      className="flex items-center justify-between border-b p-6 pb-4"
      role="region"
      data-testid="bulk-message-header"
      aria-labelledby="bulk-message-title"
    >
      <h1 id="bulk-message-title" className="text-2xl font-bold">
        {t("bulkMessaging.titleBulkMessage")}
      </h1>
      <Button
        data-testid="create-bulk-message-button"
        onClick={() => navToRoute("createBulkMessage")}
      >
        <PlusIcon />
        {t("bulkMessaging.createBulkMessage")}
      </Button>
    </section>
  );
}
